import { StepActivationId, TeamId, UserId } from '../../../BrandedIds';
import { Actor } from '../../../events/BaseLoanEvent';
import { Temporal } from '../../../Temporal';

export interface SerializedAssignmentInstance {
  userIds: UserId[];
  teamIds?: TeamId[];
  timestamp: Temporal.ZonedDateTimeLike | string;
  actor: Actor;
  isManual: boolean;
  activationId: StepActivationId;
}

export interface AssignmentInstance extends SerializedAssignmentInstance {
  teamIds: TeamId[];
  timestamp: Temporal.ZonedDateTime;
}

export function reviveAssignmentInstance(serialized: SerializedAssignmentInstance): AssignmentInstance {
  return {
    teamIds: [],
    ...serialized,
    timestamp: Temporal.ZonedDateTime.from(serialized.timestamp),
  };
}
